import React from 'react';
import PropTypes from 'prop-types';

const InlineMessage = ({ classes, children }) => (
  <div className={`bg-green color-white p-a-3 border-1 border-color-green--dark border-radius-l ${classes}`}>
    {children}
  </div>
);

InlineMessage.propTypes = {
  classes: PropTypes.string,
  children: PropTypes.object.isRequired,
};

export default InlineMessage;



// WEBPACK FOOTER //
// ./library/app/components/Global/Messages/InlineMessage.js